import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../axiosConfig';
import TrainerLayout from './TrainerLayout';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import { IoArrowBack } from 'react-icons/io5';
import '../../styles/OwnerDetails.css';

const OwnerDetails = () => {
    const { ownerId } = useParams(); // Get ownerId from URL
    const navigate = useNavigate();
    const [owner, setOwner] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        const fetchOwnerDetails = async () => {
            try {
                // Fetch owner details
                const response = await axios.get(`/api/v1/owner/details/${ownerId}`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('jwt')}` },
                });
                setOwner(response.data);
            } catch (err) {
                setError('Pobieranie danych właściciela nie powiodło się.');
            } finally {
                setLoading(false);
            }
        };

        fetchOwnerDetails();
    }, [ownerId]);

    const formatAddress = (address) => {
        if (!address) return 'Brak danych';
        return `${address.street} ${address.buildingNumber}${address.apartmentNumber ? '/' + address.apartmentNumber : ''}, ${address.postalCode} ${address.city}, ${address.country}`;
    };

    const handleDeleteClick = () => {
        setIsDeleteModalOpen(true);
    };

    const handleDeleteConfirm = async () => {
        setIsDeleting(true);
        try {
            await axios.put(`/api/v1/owner/remove-from-school/${ownerId}`, null, {
                headers: { Authorization: `Bearer ${localStorage.getItem('jwt')}` },
            });
            // Navigate back to owners list after successful deletion
            navigate('/owners/all');
        } catch (err) {
            setError('Nie udało się usunąć właściciela.');
            setIsDeleteModalOpen(false);
        } finally {
            setIsDeleting(false);
        }
    };

    const handleDeleteCancel = () => {
        setIsDeleteModalOpen(false);
    };

    const handleBackToOwners = () => {
        navigate('/owners/all');
    };

    return (
        <TrainerLayout>
            {loading ? (
                <div className="owner-details__loading">Ładowanie danych właściciela...</div>
            ) : error ? (
                <p className="error">{error}</p>
            ) : (
                <div className="owner-details">
                    {/* Back Arrow Button */}
                    <button
                        className="owner-details__back-btn"
                        onClick={handleBackToOwners}
                        aria-label="Wróć do właścicieli"
                    >
                        <IoArrowBack />
                    </button>

                    {/* Owner Information Section */}
                    <div className="owner-details__section">
                        <div className="owner-details__header">
                            <h3 className="owner-details__section-title">Informacje o właścicielu</h3>
                            <button
                                className="owner-details__delete-btn"
                                onClick={handleDeleteClick}
                                disabled={isDeleting}
                            >
                                {isDeleting ? 'Usuwanie...' : 'Usuń właściciela'}
                            </button>
                        </div>

                        {/* All owner fields in one row for flexible layout */}
                        <div className="owner-details__row owner-details__row--owner-info">
                            <div className="owner-details__field-group">
                                <label className="owner-details__label">Imię</label>
                                <input
                                    className="owner-details__input"
                                    type="text"
                                    value={owner.username || "Brak danych"}
                                    disabled
                                    placeholder="Imię właściciela"
                                />
                            </div>
                            <div className="owner-details__field-group">
                                <label className="owner-details__label">E-mail</label>
                                <input
                                    className="owner-details__input"
                                    type="text"
                                    value={owner.email || "Brak danych"}
                                    disabled
                                    placeholder="E-mail właściciela"
                                />
                            </div>
                            <div className="owner-details__field-group">
                                <label className="owner-details__label">Telefon</label>
                                <input
                                    className="owner-details__input"
                                    type="text"
                                    value={owner.phone || "Brak danych"}
                                    disabled
                                    placeholder="Numer telefonu"
                                />
                            </div>
                            <div className="owner-details__field-group">
                                <label className="owner-details__label">Adres</label>
                                <input
                                    className="owner-details__input"
                                    type="text"
                                    value={formatAddress(owner.address)}
                                    disabled
                                    placeholder="Adres właściciela"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            <DeleteConfirmationModal
                isOpen={isDeleteModalOpen}
                onClose={handleDeleteCancel}
                onConfirm={handleDeleteConfirm}
                itemName={owner ? `${owner.firstName && owner.lastName ? `${owner.firstName} ${owner.lastName}` : owner.username}` : 'tego właściciela'}
            />
        </TrainerLayout>
    );
};

export default OwnerDetails;